<template>
  <div class="telegram-app">
    <router-view />

    <nav class="telegram-bottom-nav">
      <router-link to="/telegram/home" class="nav-item">
        <Home class="icon" />
        <span>Home</span>
      </router-link>

      <router-link to="/telegram/submit" class="nav-item">
        <Pencil class="icon" />
        <span>Write</span>
      </router-link>

      <router-link to="/telegram/whitepaper" class="nav-item">
        <Scroll class="icon" />
        <span>Paper</span>
      </router-link>

      <router-link to="/telegram/about" class="nav-item">
        <Info class="icon" />
        <span>About</span>
      </router-link>
    </nav>
  </div>
</template>

<script setup>
import { Home, Pencil, Scroll, Info } from 'lucide-vue-next';
</script>

<style scoped>
.telegram-app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #fafafa;
}

.telegram-bottom-nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #BB6622;
  padding: 8px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-shadow: 0 -2px 5px rgba(0,0,0,0.3);
  border-top: 2px solid #fff;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  text-decoration: none;
  flex: 1;
  padding: 6px 0;
}

.icon {
  width: 24px;
  height: 24px;
  color: white;
}

.nav-item span {
  font-size: 12px;
  margin-top: 2px;
}
</style>